module.exports = __webpack_public_path__ + "static/boots_of_elvenkind-7917febb4798c1f7221d1b67ca4655fd.jpeg";